import script from "./RelateArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./RelateArticle.vue?vue&type=script&setup=true&lang=js"

import "./RelateArticle.vue?vue&type=style&index=0&id=880e5388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-880e5388"]])

export default __exports__